
import { ISelectItem } from "src/classes";
import Vue from "vue";
import { isChildOf } from "../utils/dom";

export default Vue.extend({
	data() {
		return {
			isOpened: false
		};
	},
	props: {
		items: Array as () => ISelectItem<any>[],
		right: Boolean,
		hideArrow: Boolean
	},
	computed: {
		activator():HTMLElement {
			let item = this.$refs.activator as HTMLElement;
			return item;
		}
	},
	methods: {
		itemClicked(value: any) {
			if (value) {
				this.$emit("click", value);
			}
			this.isOpened = false;
		},
		onItemsBlur(){
			requestAnimationFrame(()=>{
				let activeElement = document.activeElement;
				let itemsRootVue = this.$refs.itemsRoot as Vue | null;
				if (!itemsRootVue){
					this.isOpened = false;
					return;
				}
				let itemsRoot = itemsRootVue.$el as HTMLElement;
				if (!activeElement) {
					this.isOpened = false;
					return;
				};
				if (this.activator == activeElement){
					return;
				}
				if (itemsRoot == activeElement){
					return;
				}
				if (isChildOf(itemsRoot, activeElement as HTMLElement)){
					return;
				};
				if (isChildOf(this.activator, activeElement as HTMLElement)){
					return;
				}
				this.isOpened = false;
			});
		}
	}
});
